Turbo.StreamActions.redirect = function () {
  const url = this.getAttribute('url') || '/';
  Turbo.visit(url, { frame: '_top', action: 'advance' });
};
